import styles from "./styles.module.scss";

const Loader = () => (
  <div className={styles.container}>
    <div className={styles.loader}></div>
  </div>
);

export default Loader;
